import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface SeverityWiseIssueCountState {
    inhouseissuecount: {
        load: boolean;
        data: [];
    };
    tpiissuecount: {
        load: boolean;
        data: [];
    };
}

export const RackHealthGraphDataSlice = createSlice({
    name: "inhouseissuecount",
    initialState: {
        inhouseissuecount: {
            load: false,
            data: [],
        },
        tpiissuecount: {
            load: false,
            data: [],
        },
    } as SeverityWiseIssueCountState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchinhouseissuecount.pending, (state: SeverityWiseIssueCountState) => {
                state.inhouseissuecount.load = true;
            })
            .addCase(fetchinhouseissuecount.fulfilled, (state: SeverityWiseIssueCountState, action: any) => {
                state.inhouseissuecount.data = action.payload;
                state.inhouseissuecount.load = false;
            })
            .addCase(fetchinhouseissuecount.rejected, (state: SeverityWiseIssueCountState) => {
                state.inhouseissuecount.load = false;
            })
            .addCase(fetchtpiissuecount.pending, (state: SeverityWiseIssueCountState) => {
                state.tpiissuecount.load = true;
            })
            .addCase(fetchtpiissuecount.fulfilled, (state: SeverityWiseIssueCountState, action: any) => {
                state.tpiissuecount.data = action.payload;
                state.tpiissuecount.load = false;
            })
            .addCase(fetchtpiissuecount.rejected, (state: SeverityWiseIssueCountState) => {
                state.tpiissuecount.load = false;
            });
    },
});

export default RackHealthGraphDataSlice.reducer;

export const fetchinhouseissuecount = createAsyncThunk(
    "inhouseissuecount/fetchinhouseissuecount",
    async (param: { apiParam: { layout_pin: any, warehouse_id: any, status: any } }) => {
        try {
            const { data } = await DataServer.post("api/getSeverityWiseInhouseOpenIssue", {
                warehouse_id: param.apiParam.warehouse_id,
                layout_id: param.apiParam.layout_pin,
                status: param.apiParam.status
            });

            return data.data;
        } catch (error) {
            return error;
        }

    }

);

export const fetchtpiissuecount = createAsyncThunk(
    "inhouseissuecount/fetchtpiissuecount",
    async (param: { apiParam: { layout_pin: any, warehouse_id: any } }) => {
        try {
            const { data } = await DataServer.post("api/getSeverityWiseTpiOpenIssue", {
                warehouse_id: param.apiParam.warehouse_id,
                layout_id: param.apiParam.layout_pin
            });

            return data.data;
        } catch (error) {
            return error;
        }
    }
);
